import A from 'utils/metrics/analytic'

// Открытие страницы будущего вебинара

enum originPWebinar {
  WEBINAR_PAST_LIST = 'webinar_past_list',
  VIDEOPROJECT = 'videoproject',
  PLAYLIST = 'playlist',
  FEED = 'feed',
}

const A_wp_openWebinar = (origin: originPWebinar) => {
  A.setEvent('webinar_past_open', { origin })
  console.log('Открыл прошлый вебинар', origin)
}

export { A_wp_openWebinar, originPWebinar }
